import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FondsEvenementielsService } from '@lib/services/fonds-evenementiels.service';
import { OuiSelectOption } from 'omnium-ui/form-field';
import { DraftOperationsService } from 'src/service/draft-operation/draft-operation.service';
import { AbstractSpecificFieldComponent } from '../abstract-specific-field.component';

const FONDS_IDS = 'fondEvenementielIds';
// Clé transmise par Proxeema : gammes de fonds événementiels cochées dans le conseil digital.
const GAMMES_PROXEEMA = 'gammesFondsEvenementiels';
const GAMME_EXCELTIS = 'GAMME_EXCELTIS';

@Component({
    selector: 'app-fonds-evenementiels',
    templateUrl: './fonds-evenementiels.component.html',
    styleUrls: ['./fonds-evenementiels.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FondsEvenementielsComponent extends AbstractSpecificFieldComponent<string> {
  // required input for this component
  @Input({ required: true }) override operationIndex: number;

  options: OuiSelectOption<number>[] = [];
  productId: number;
  hint?: string;

  override getDataName(): string {
    return FONDS_IDS;
  }
  override wrapData(value: string): string {
    return value;
  }
  constructor(
    private draftOperationsService: DraftOperationsService,
    private fondsEvenementielsService: FondsEvenementielsService
  ) {
    super();
  }

  override ngOnInit(): void {
    // La gamme choisie dans Proxeema ne suffit pas : le consultant doit préciser les fonds Exceltis (US 30327).
    const gammes: unknown = this.initialData?.data?.[GAMMES_PROXEEMA];
    if (Array.isArray(gammes) && gammes.includes(GAMME_EXCELTIS)) {
      this.isRequired = true;
      this.hint = 'Vous devez préciser le ou les fonds événementiel sélectionné(s) dans la gamme Exceltis.';
    }
    super.ngOnInit();
    if (this.operationIndex !== undefined) {
      this.productId =
        this.draftOperationsService.operationGroupData.operations[this.operationIndex]?.produitId ??
        this.draftOperationsService.operationGroupData.operations[this.operationIndex!].produit?.id ??
        0;
    }
    this.getfondEvenementielsByProductId();
  }

  override isFormValid(): boolean {
    if (this.control.disabled) {
      return true;
    }
    return this.control.valid;
  }
  override markAsTouched() {
    this.control.markAsTouched();
  }
  async getfondEvenementielsByProductId() {
    const fondsEvenementiels = await this.fondsEvenementielsService.getfondEvenementielsByProductId(this.productId);

    this.options = fondsEvenementiels.map(fondEvenementiel => ({
      label: fondEvenementiel.libelle,
      value: fondEvenementiel.id,
    }));
    if (this.options.length < 1) {
      this.control.disable();
      // Un champ obligatoire sans fonds proposé ne doit pas bloquer la déclaration : republier sa validité.
      this.onDataChange({
        dataSource: this.getDataName(),
        data: { isFormValid: this.isFormValid(), data: this.metadata },
      });
    }
  }
}
